export default {
  computed: {
    safeArea () {
      const styleDeclaration = getComputedStyle(document.documentElement)

      return {
        top: parseInt(styleDeclaration.getPropertyValue('--sat')),
        bottom: parseInt(styleDeclaration.getPropertyValue('--sab')),
        left: parseInt(styleDeclaration.getPropertyValue('--sal')),
        right: parseInt(styleDeclaration.getPropertyValue('--sar'))
      }
    }
  }
}
